import { PageComponentKeys, PageComponents } from './main';

export function pageNameToJSX(name: PageComponentKeys, props: any) {
  const Component = PageComponents[name];
  return <Component {...props} />;
}
